import { render, staticRenderFns } from "./LandingFonctionnalites.vue?vue&type=template&id=6b306b99&scoped=true"
import script from "./LandingFonctionnalites.vue?vue&type=script&lang=js"
export * from "./LandingFonctionnalites.vue?vue&type=script&lang=js"
import style0 from "./LandingFonctionnalites.vue?vue&type=style&index=0&id=6b306b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b306b99",
  null
  
)

export default component.exports